import { InfoBoxResp } from 'types/api/response/info-box-resp'

import { api } from './api'

export const getInfoBox = () => api.get<InfoBoxResp>('faq_entries/faq_infobox')
